<div class="entity-header"> </div>
@if (!serverAction && company) {
    <div>
        <div class="row equal-panel">
            @if (enableDynamicCompanyPage) {
                <div class="col-xl-4">
                    <company-info-panel
                        [company]="company"
                        [enableDynamicCompanyPage]="true"
                        [entity]="entity"
                    ></company-info-panel>
                </div>
                <div class="col-xl-3">
                    <quick-links [company]="company" [isTopLevelCompany]="isTopLevel" [parentCompany]="parentCompany">
                    </quick-links>
                </div>
                <div class="col-xl-5">
                    <company-exploration [company]="company"></company-exploration>
                </div>
            } @else {
                <div class="col-xl-6">
                    <company-info-panel
                        [company]="company"
                        [enableDynamicCompanyPage]="false"
                        [entity]="entity"
                    ></company-info-panel>
                </div>
                <div class="col-xl-6">
                    <company-exploration-old [company]="company"></company-exploration-old>
                </div>
            }
        </div>
        <div>
            @if (!enableDynamicCompanyPage) {
                <div class="row">
                    <div class="col-xl-12">
                        <client-services-panel
                            (ppReturnPreparationAllowedChanged)="setShowComplianceInfo($event)"
                            [company]="company"
                            [entity]="entity"
                        >
                        </client-services-panel>
                    </div>
                </div>
            }
            @if (showReferralsPanel) {
                <div class="row">
                    <div class="col-xl-12">
                        <referrals-panel [companyId]="company.companyID"></referrals-panel>
                    </div>
                </div>
            }
            @if (!enableDynamicCompanyPage && showComplianceInfo) {
                <div class="row">
                    <div class="col-xl-12">
                        <company-compliance
                            [company]="company"
                            [isTopLevelCompany]="isTopLevel"
                            [parentCompany]="parentCompany"
                        >
                        </company-compliance>
                    </div>
                </div>
            }
            @if (!enableDynamicCompanyPage && !showComplianceInfo) {
                <div class="row">
                    <div class="col-xl-12 panel-container">
                        <compliance-company-return-settings-panel
                            [allowEdit]="hasWritePermission"
                            [companyId]="company.companyID"
                        >
                        </compliance-company-return-settings-panel>
                    </div>
                </div>
            }
            @if (hasPrivateItemsPermission && !enableDynamicCompanyPage) {
                <div class="row">
                    <div class="col-xl-12">
                        <contract-terms-panel-company [entity]="entity" [isTopLevel]="isTopLevel">
                        </contract-terms-panel-company>
                    </div>
                </div>
            }
            @if (hasPrivateItemsPermission && !enableDynamicCompanyPage) {
                <div class="row">
                    <div class="col-xl-12">
                        <invoice-panel [allowEdit]="allowInvoiceEdit" [company]="entity"></invoice-panel>
                    </div>
                </div>
            }
            @if (!enableDynamicCompanyPage) {
                <div class="row">
                    <div class="col-xl-12">
                        <company-settings-old
                            [allowEdit]="hasWritePermission"
                            [companyId]="company.companyID"
                            [company]="company"
                            [isTopLevelCompany]="isTopLevel"
                            [parentCompany]="parentCompany"
                        >
                        </company-settings-old>
                    </div>
                </div>
            }
            <div class="row">
                <div class="col-xl-12">
                    <contacts-panel [entity]="entity"></contacts-panel>
                </div>
            </div>
            @if (!enableDynamicCompanyPage && isTopLevel) {
                <div class="row">
                    <div class="col-xl-12">
                        <div class="card panel-flat-color secondary-panel">
                            <property-characteristics-overrides-panel></property-characteristics-overrides-panel>
                        </div>
                    </div>
                </div>
            }
            <div>
                <div class="col-xl-12">
                    <entity-property-characteristics [isCompany]="true"></entity-property-characteristics>
                </div>
            </div>
        </div>
    </div>
}
